// تایپ های اضافه شده فقط برای اضافه شدن اینتلیسنس در زمان استفاده از سرویس است.
import { uploadMedia, uploadMediasTypes, MediaResponse } from './';

export const uploadMedias = async ({
  medias,
  ft,
  fi,
  mcs = [],
  fis = [],
  urls = [],
  options,
}: uploadMediasTypes) => {
  const responses: MediaResponse[] = [];
  const callback = (payload, callback = () => {}) => {
    responses.push(payload);
    callback(responses);
  };
  return (medias || []).reduce(
    (acc, curr, ci) =>
      acc.then(
        (_) =>
          new Promise((resolve, reject) => {
            if (!(curr instanceof File)) return callback(null, resolve);
            const payload = {
              ft,
              fi: fis[ci] || fi,
              ma: curr,
              ...(mcs[ci] ? { mc: mcs[ci] } : {}),
              ...(urls[ci] ? { io: JSON.stringify({ url: urls[ci] }) } : {}),
            };
            uploadMedia(payload, options)
              .then((response) => callback(response.data.result.media, resolve))
              .catch((err) => callback(err, reject));
          })
      ),
    Promise.resolve(responses)
  );
};
